import { IModifier } from './Modifier';
import { EAnimationModifiers } from '../../Animation/SpineWrapperEventManager';
import { getAllEventModifiers } from '../../Utils/ModifierUtils';
import { GameStore } from '@GameStore/GameStore';
import { getSymbolRoles } from '@Core/Utils/SymbolUtils';
import { ESymbolRoles } from '@Core/Reels/SymbolRoles';

export class SpecialSymbolModifier implements IModifier {
    constructor(
        readonly gameStore: GameStore,
        readonly symbolId: number
    ) {}

    public modifierCheck(name: string): boolean {
        return getAllEventModifiers(name).includes(EAnimationModifiers.SPECIAL);
    }

    public requirementCheck(name: string): boolean {
        return getSymbolRoles(this.gameStore, this.symbolId).includes(ESymbolRoles.SPECIAL_SYMBOL);
    }
}
